<header class="flex fixed w-full l-0 t-0 bg-white px-20 pt-6 pb-12 z-20 rounded-b-lg shadow-lg">
  <progress-tab d-contents [countTab]="count"></progress-tab>
</header>

<main class="pt-28">
  <div class="w-full p-3 sm:p-5 md:p-8">
    <h1 class="text-center font-bold mb-5"> EXAMPLES</h1>
    <section class="mb-4">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <h3 class="ml-4">button type solid</h3>
          <app-button d-contents background="primary" type="solid" shape="round" size="large" [loading]="false"
            (click)="nextStep()" role="button" tabindex="0">
            <p title-button>
              NEXT
            </p>
          </app-button>
        </div>
        <div>
          <h3 class="ml-4">button type solid disabled</h3>
          <app-button d-contents background="primary" type="solid" shape="round" size="large" [loading]="false"
            [disabled]="true" role="button" tabindex="0" (click)="next()">
            <p title-button>
              CONTINUAR
            </p>
          </app-button>
        </div>

        <div>
          <h3 class="ml-4">button type outline</h3>
          <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
            (click)="prevStep()" role="button" tabindex="0">
            <p title-button>
              PREV
            </p>
          </app-button>
        </div>
        <div>
          <h3 class="ml-4">button type outline disabled</h3>
          <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
            [disabled]="true" role="button" tabindex="0" (click)="next()">
            <p title-button>
              FILTRAR
            </p>
          </app-button>
        </div>

        <div>
          <h3 class="ml-4">button solid loading</h3>
          <app-button d-contents background="primary" type="solid" shape="round" size="large" [loading]="true"
            role="button" tabindex="0" (click)="next()">
            <p title-button>
              FILTRAR
            </p>
          </app-button>
        </div>

        <div>
          <h3 class="ml-4">button outline loading</h3>
          <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="true"
            role="button" tabindex="0" (click)="next()">
            <p title-button>
              FILTRAR
            </p>
          </app-button>
        </div>
      </div>
    </section>

    <form [formGroup]="form">
      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Input File type outline with text align to left</h3>
            <app-input (click)="inputFile.click()">
              <input
                [ngClass]="{'fill': form.get('files')!.value?.value, 'input-error': ((form.get('files')!.invalid && form.get('files')!.dirty))}"
                maxlength="100" appRemovefirstspace PreventDragAndDrog appInputEffect type="text" readonly
                autocomplete="off" red-input redType="outline" id="files" formControlName="files"
                [value]="form.get('files')!.value?.value" />
              <label for="files" red-label>files</label>
              <app-icon red-icon redIconAlign="right" size="small">
                <fa-icon [icon]="faDownload" class="color-secondary"></fa-icon>
              </app-icon>
              <input #inputFile type="file" accept=".png" hidden class="hidden none absolete left-0 top-0"
                (change)="onFileSelected(inputFile)">
            </app-input>
            @if (!!errorMessage) {
            <div class="w-full mt-3">
              <chip-error [text]="errorMessage"></chip-error>
            </div>
            }
          </div>

        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Input type outline with text align to left</h3>
            <app-input>
              <input
                [ngClass]="{'fill': form.get('name')!.value, 'input-error': ((form.get('name')!.invalid && form.get('name')!.dirty))}"
                maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                autocomplete="off" red-input redType="outline" id="name" formControlName="name" />
              <label for="name" red-label>Intermediario</label>
            </app-input>
          </div>

          <div>
            <h3 class="ml-4">Input type outline with text align to center</h3>
            <app-input>
              <input
                [ngClass]="{'fill': form.get('intermediario')!.value, 'input-error': ((form.get('intermediario')!.invalid && form.get('intermediario')!.dirty))}"
                maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                redTextAlign="center" autocomplete="off" red-input redType="outline" id="intermediario"
                formControlName="intermediario" />
              <label for="intermediario" red-label redTextAlign="center">Intermediario</label>
            </app-input>
          </div>

          <div>
            <h3 class="ml-4">Input type disalbed</h3>
            <app-input>
              <input
                [ngClass]="{'fill': form.get('apellido')!.value, 'input-error': ((form.get('apellido')!.invalid && form.get('apellido')!.dirty))}"
                maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                autocomplete="off" red-input redType="outline" id="apellido" formControlName="apellido" />
              <label for="apellido" red-label>Apellido</label>
            </app-input>
          </div>

          <div>
            <h3 class="ml-4">Input type Error</h3>
            <app-input>
              <input [ngClass]="{'fill': form.get('telefono')!.value, 'input-error': true}" maxlength="20" appUpper
                appRemovefirstspace PreventDragAndDrog appInputEffect type="text" autocomplete="off" red-input
                redType="outline" id="telefono" formControlName="telefono" />
              <label for="telefono" red-label>Telefono</label>
            </app-input>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Select type outline with text align to left</h3>
            <app-select>
              <nz-select [nzOptionHeightPx]="42" red-select formControlName="opcion" appInputEffect id="opcion"
                [ngClass]="{'fill': form.get('opcion')!.value, 'input-error': ((form.get('opcion')!.invalid && form.get('opcion')!.dirty))}"
                redType="outline" background-blue25 [nzOptionOverflowSize]="10" nzShowSearch>
                <nz-option [nzValue]="1" [nzLabel]="'opcion numero 1'"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'opcion numero 2'"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'opcion numero 3'"></nz-option>
              </nz-select>
              <label for="opcion" red-label>Tipo de documento cliente</label>
            </app-select>
          </div>
          <div>
            <h3 class="ml-4">Select type outline with text align to center</h3>
            <app-select>
              <nz-select [nzOptionHeightPx]="42" red-select formControlName="opcionDos" appInputEffect id="opcionDos"
                [ngClass]="{'fill': form.get('opcionDos')!.value, 'input-error': ((form.get('opcionDos')!.invalid && form.get('opcionDos')!.dirty))}"
                redType="outline" redTextAlign="center" background-blue25 [nzOptionOverflowSize]="10" nzShowSearch>
                <nz-option [nzValue]="1" [nzLabel]="'opcion numero 1'"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'opcion numero 2'"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'opcion numero 3'"></nz-option>
              </nz-select>
              <label for="opcionDos" red-label redTextAlign="center">Tipo de documento cliente</label>
            </app-select>
          </div>
          <div>
            <h3 class="ml-4">Select type disabled</h3>
            <app-select>
              <nz-select [nzOptionHeightPx]="42" red-select formControlName="opcionTres" appInputEffect id="opcionTres"
                [ngClass]="{'fill': form.get('opcionTres')!.value, 'input-error': ((form.get('opcionTres')!.invalid && form.get('opcionTres')!.dirty))}"
                redType="outline" background-blue25 [nzOptionOverflowSize]="10" nzShowSearch [nzLoading]="true">
                <nz-option [nzValue]="1" [nzLabel]="'opcion numero 1'"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'opcion numero 2'"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'opcion numero 3'"></nz-option>
              </nz-select>
              <label for="opcionTres" red-label>Tipo de documento cliente</label>
            </app-select>
          </div>
          <div>
            <h3 class="ml-4">Select type error</h3>
            <app-select>
              <nz-select [nzOptionHeightPx]="42" red-select formControlName="opcionCuatro" appInputEffect
                [ngClass]="{'fill': form.get('opcionCuatro')!.value, 'input-error': true}" id="opcionCuatro"
                redType="outline" background-blue25 [nzOptionOverflowSize]="10" nzShowSearch>
                <nz-option [nzValue]="1" [nzLabel]="'opcion numero 1'"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'opcion numero 2'"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'opcion numero 3'"></nz-option>
              </nz-select>
              <label for="opcionCuatro" red-label>Tipo de documento cliente</label>
            </app-select>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Date Picker type outline with text align to left</h3>
            <app-date-picker d-contents>
              <nz-date-picker background-blue25 [ngClass]="{
                                    'fill hoverstate': form.get('fechaInicial')!.value || form.get('fechaInicial')!.value == 0,
                                    'input-error': form.get('fechaInicial')!.invalid && form.get('fechaInicial')!.dirty
                                }" [nzInputReadOnly]="'true'" class="w-100 black2" name="date"
                formControlName="fechaInicial" tabindex="0" nzPlaceHolder="Fecha" [nzSuffixIcon]="icon"
                [nzShowToday]="true" red-label-effect red-input redType="outline" class="datepicker"
                [nzDisabledDate]="disabledStartDate" [nzFormat]="dateFormat"
                (ngModelChange)="addValidatorDateStartEnd()" id="fechaInicial">
              </nz-date-picker>
              <label for="fechaInicial" class="fz-14 text-ellipsis color-secondary" red-label>Fecha inicial</label>
              <ng-template #icon>
                <fa-icon [icon]="faCalendar" class="color-secondary cursor-pointer"></fa-icon>
              </ng-template>
            </app-date-picker>
          </div>
          <div>
            <h3 class="ml-4">Date Picker outline with text align to center</h3>
            <app-date-picker d-contents>
              <nz-date-picker background-blue25 [ngClass]="{
                                    'fill hoverstate': form.get('fechaFinal')!.value || form.get('fechaFinal')!.value == 0,
                                    'input-error': form.get('fechaFinal')!.invalid && form.get('fechaFinal')!.dirty
                                }" [nzInputReadOnly]="'true'" class="w-100 black2" name="date"
                formControlName="fechaFinal" tabindex="0" nzPlaceHolder="Fecha" [nzSuffixIcon]="icon"
                [nzShowToday]="true" red-label-effect red-input redType="outline" class="datepicker"
                redTextAlign="center" [nzDisabledDate]="disabledEndDate" [nzFormat]="dateFormat"
                (ngModelChange)="addValidatorDateStartEnd()" id="fechaFinal">
              </nz-date-picker>
              <label for="fechaFinal" class="fz-14 text-ellipsis color-secondary" red-label redTextAlign="center">Fecha
                Final</label>
              <ng-template #icon>
                <fa-icon [icon]="faCalendar" class="color-secondary cursor-pointer"></fa-icon>
              </ng-template>
            </app-date-picker>
          </div>
          <div>
            <h3 class="ml-4">Date Picker type disabled</h3>
            <app-date-picker d-contents>
              <nz-date-picker background-blue25 [ngClass]="{
                                    'fill hoverstate': form.get('fechaDisabled')!.value || form.get('fechaDisabled')!.value == 0,
                                    'input-error': form.get('fechaDisabled')!.invalid && form.get('fechaDisabled')!.dirty
                                }" [nzInputReadOnly]="'true'" class="w-100 black2" name="date"
                formControlName="fechaDisabled" tabindex="0" nzPlaceHolder="Fecha" [nzSuffixIcon]="icon"
                [nzShowToday]="true" red-label-effect red-input redType="outline" class="datepicker"
                [nzDisabled]="form.get('fechaDisabled')!.disabled" id="fechaDisabled">
              </nz-date-picker>
              <label for="fechaDisabled" class="fz-14 text-ellipsis color-secondary" red-label>Fecha Disabled</label>
              <ng-template #icon>
                <fa-icon [icon]="faCalendar" class="color-secondary cursor-pointer"></fa-icon>
              </ng-template>
            </app-date-picker>
          </div>
          <div>
            <h3 class="ml-4">Date Picker type error</h3>
            <app-date-picker d-contents>
              <nz-date-picker background-blue25 [ngClass]="{
                                    'fill hoverstate': form.get('fechaError')!.value || form.get('fechaError')!.value == 0,
                                    'input-error': true
                                }" [nzInputReadOnly]="'true'" class="w-100 black2" name="date"
                formControlName="fechaError" tabindex="0" nzPlaceHolder="Fecha" [nzSuffixIcon]="icon"
                [nzShowToday]="true" red-label-effect red-input redType="outline" class="datepicker" id="fechaError">
              </nz-date-picker>
              <label for="fechaError" class="fz-14 text-ellipsis color-secondary" red-label>Fecha Error</label>
              <ng-template #icon>
                <fa-icon [icon]="faCalendar" class="color-secondary cursor-pointer"></fa-icon>
              </ng-template>
            </app-date-picker>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Toggle value</h3>
            <toggle class="toggle" formControlName="afCard" [invalid]="false"></toggle>
          </div>
          <div>
            <h3 class="ml-4">Toggle Invalid</h3>
            <toggle class="toggle" formControlName="afCardInvalid" [invalid]="true"></toggle>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h3 class="ml-4">Chi-Error</h3>
            <chip-error text="Debes diligenciar todos los campos en rojo"></chip-error>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="grid grid-cols-4 gap-4">
          <div>
            <h3 class="ml-4">Modal Success</h3>
            <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
              (click)="succes()" role="button" tabindex="0">
              <p title-button>
                Succes
              </p>
            </app-button>
          </div>
          <div>
            <h3 class="ml-4">Modal Delete</h3>
            <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
              (click)="delete()" role="button" tabindex="0">
              <p title-button>
                Delete
              </p>
            </app-button>
          </div>
          <div>
            <h3 class="ml-4">Modal Hold Up</h3>
            <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
              (click)="holdUp()" role="button" tabindex="0">
              <p title-button>
                Hold Up
              </p>
            </app-button>
          </div>
          <div>
            <h3 class="ml-4">Modal Detected</h3>
            <app-button d-contents background="primary" type="outline" shape="round" size="large" [loading]="false"
              (click)="detected()" role="button" tabindex="0">
              <p title-button>
                Detected
              </p>
            </app-button>
          </div>
        </div>
      </section>

      <section class="mb-4 grid grid-cols-2 gap-2">
        <div class="">
          <div>
            <h3 class="ml-4">Business Example</h3>
            <div class="card-business">
              <img src="/img/TARJETA_1.png" alt="Tarjeta" class="card-image ">
              <div class="card-content">
                <div class="grid grid-cols-3 gap-0 mb-[5%]">
                  <div class="col-span-2 inline">
                    <h1 class="text-[1.34em] color-white RedHatBold">Business Example</h1>
                    <p class="text-[0.56em] color-white mb-2.5">Client ID: <span>00000</span></p>
                    <div class="flex gap-2">
                      <div class="w-2/4 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                      <div class="w-0.5 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                      <div class="w-0.5 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                    </div>
                  </div>
                  <div class="col-start-3 col-end-4 inline">
                    <img src="/img/MoneyUp.svg" alt="MoneyUp" class="w-full max-w-32 mb-1">
                    <h3 class="text-[0.67em] color-white RedHatBold text-ellipsis text-nowrap">Store Credit Voucher</h3>
                    <p class="text-[0.56em] color-white">Voucher ID: <span>00000</span></p>
                  </div>
                </div>

                <div class="grid grid-cols-6 gap-0 mb-[3.6%]">
                  <div class="col-span-1 inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">USD</h2>
                    <p class="text-[0.56em] color-white">Currency</p>
                  </div>
                  <div class="col-start-2 col-end-auto inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">$000,000,000.00</h2>
                    <p class="text-[0.56em] color-white">Availability</p>
                  </div>
                  <div class="col-start-5 col-end-7 inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">24 Days</h2>
                    <p class="text-[0.56em] color-white">Forecasted Days to Go</p>
                  </div>
                </div>

                <div class="box-color w-full mb-[3.6%]">
                  <div class="grid grid-cols-3 gap-0 text-nowrap">
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Current balance</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Credit Limit</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Daily Avg. Consumption</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-6 gap-0 pl-[3.5%] text-nowrap">
                  <div class="col-span-2 inline">
                    <p class="text-[0.56em] color-white RedHatBold">User Spread: <span
                        class="RedHatRegular">00.00%</span></p>
                  </div>
                  <div class="col-start-3 col-end-6 inline">
                    <p class="text-[0.56em] color-white RedHatBold">Client Premium (Fee): <span
                        class="RedHatRegular">00.00%</span></p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div>
            <h3 class="ml-4">Business Example Suspend</h3>
            <div class="card-business card-image-supendida">
              <img src="/img/TARJETA_1.png" alt="Tarjeta" class="card-image ">
              <div class="card-content">
                <div class="grid grid-cols-3 gap-0 mb-[5%]">
                  <div class="col-span-2 inline">
                    <h1 class="text-[1.34em] color-white RedHatBold">Business Example</h1>
                    <p class="text-[0.56em] color-white mb-2.5">Client ID: <span>00000</span></p>
                    <div class="flex gap-2">
                      <div class="w-2/4 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                      <div class="w-0.5 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                      <div class="w-0.5 h-0.5 bg-tertiary-green-01 rounded-full"></div>
                    </div>
                  </div>
                  <div class="col-start-3 col-end-4 inline">
                    <img src="/img/MoneyUp.svg" alt="MoneyUp" class="w-full max-w-32 mb-1">
                    <h3 class="text-[0.67em] color-white RedHatBold text-ellipsis text-nowrap">Store Credit Voucher</h3>
                    <p class="text-[0.56em] color-white">Voucher ID: <span>00000</span></p>
                  </div>
                </div>

                <div class="grid grid-cols-6 gap-0 mb-[3.6%]">
                  <div class="col-span-1 inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">USD</h2>
                    <p class="text-[0.56em] color-white">Currency</p>
                  </div>
                  <div class="col-start-2 col-end-auto inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">$000,000,000.00</h2>
                    <p class="text-[0.56em] color-white">Availability</p>
                  </div>
                  <div class="col-start-5 col-end-7 inline">
                    <h2 class="text-[1em] color-white RedHatBold mb-1">24 Days</h2>
                    <p class="text-[0.56em] color-white">Forecasted Days to Go</p>
                  </div>
                </div>

                <div class="box-color w-full mb-[3.6%]">
                  <div class="grid grid-cols-3 gap-0 text-nowrap">
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Current balance</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Credit Limit</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                    <div class="w-full inline">
                      <h4 class="text-[0.56em] color-white RedHatBold">Daily Avg. Consumption</h4>
                      <p class="text-[0.56em] color-white">$000,000,000.00</p>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-6 gap-0 pl-[3.5%] text-nowrap">
                  <div class="col-span-2 inline">
                    <p class="text-[0.56em] color-white RedHatBold">User Spread: <span
                        class="RedHatRegular">00.00%</span></p>
                  </div>
                  <div class="col-start-3 col-end-6 inline">
                    <p class="text-[0.56em] color-white RedHatBold">Client Premium (Fee): <span
                        class="RedHatRegular">00.00%</span></p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  </div>
  <section>
    <h3 class="ml-4">table with filter and pagination</h3>
    <div class="filters-bds">
      <collapse title="Filters" [icono]="faFilter" [isFilters]="true">
        <form [formGroup]="parentForm">
          <div class="content-filters">
            <div class="grid grid-cols-3 gap-4 py-3 px-6 md:px-20">
              <app-input>
                <input
                  [ngClass]="{'fill': parentForm.get('name')!.value, 'input-error': ((parentForm.get('name')!.invalid && parentForm.get('name')!.dirty))}"
                  maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                  autocomplete="off" red-input redType="outline" id="name" formControlName="name" />
                <label for="name" red-label>Name</label>
              </app-input>
              <app-input>
                <input
                  [ngClass]="{'fill': parentForm.get('phone')!.value, 'input-error': ((parentForm.get('phone')!.invalid && parentForm.get('phone')!.dirty))}"
                  maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                  autocomplete="off" red-input redType="outline" id="phone" formControlName="phone" />
                <label for="phone" red-label>Phone</label>
              </app-input>
              <app-input>
                <input
                  [ngClass]="{'fill': parentForm.get('email')!.value, 'input-error': ((parentForm.get('email')!.invalid && parentForm.get('email')!.dirty))}"
                  maxlength="20" appUpper appRemovefirstspace PreventDragAndDrog appInputEffect type="text"
                  autocomplete="off" red-input redType="outline" id="email" formControlName="email" />
                <label for="email" red-label>Email</label>
              </app-input>
              <div class="col-span-full flex justify-end">
                <div class="w-full max-w-44 mr-4">
                  <app-button d-contents background="secondary" type="outline" shape="round" size="large"
                    [loading]="false" role="button" tabindex="0" (click)="next()">
                    <p title-button>
                      Clear Filters
                    </p>
                  </app-button>
                </div>
                <div class="w-full max-w-44">
                  <app-button d-contents background="secondary" type="solid" shape="round" size="large"
                    [loading]="false" role="button" tabindex="0" (click)="next()">
                    <p title-button>
                      Apply
                    </p>
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </collapse>
    </div>
    <main class="relative overflow-x-auto">
      <app-table minSize="fewColumns" fontSize="small" [marginBottom]="true">
        <thead thead>
          <tr>
            <th data-order="asc" data-name="asignados" sort scope="col">
              <div content-sort>
                <app-icon red-icon size="extra-small">
                  <fa-icon [icon]="faSort" class="color-white"></fa-icon>
                </app-icon>
                FullName
              </div>
            </th>
            <th data-order="asc" data-name="asignados" sort scope="col">
              <div content-sort>
                <app-icon red-icon size="extra-small">
                  <fa-icon [icon]="faSort" class="color-white"></fa-icon>
                </app-icon>
                <p>Email</p>
              </div>
            </th>
            <th data-order="asc" data-name="asignados" sort scope="col">
              <div content-sort>
                <app-icon red-icon size="extra-small">
                  <fa-icon [icon]="faSort" class="color-white"></fa-icon>
                </app-icon>
                <p>Client</p>
              </div>
            </th>
            <th class="text-left pl-8" sticky action scope="col" s>
              <div content-sort>
                Actions
              </div>
            </th>
          </tr>
        </thead>
        <tbody tbody>
          @for (row of rows; track idx; let idx = $index) {
          <tr>
            <td padding-text> {{row.FullName}} </td>
            <td padding-text> {{row.Email}} </td>
            <td padding-text> {{row.Client}} </td>
            <td padding-action class="d-flex justify-content-start align-items-start" sticky>
              <div actions class="d-flex align-items-start">
                <div btn-action redPrimary>
                  <app-icon red-icon size="tb-small">
                    <fa-icon [icon]="faPenToSquare" [class]="'icon-header'"></fa-icon>
                  </app-icon>
                  <p text-info>EDIT</p>
                </div>
                <div btn-action danger>
                  <app-icon red-icon size="tb-small">
                    <fa-icon [icon]="faTrashCan" [class]="'icon-header'"></fa-icon>
                  </app-icon>
                  <p text-info>DELETE</p>
                </div>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </app-table>
    </main>
    <div class="content-botton-footer red-pagination z-20" [formGroup]="formPagination" #paginacionLog
      [attr.hiddenPagination]="false">
      <div class="pagination-left">
        <app-icon [align]="'left'" (click)="prev()" class="btn-prev"
          [ngClass]="{'disabled': this.paginacion.value <= 1 || this.paginacion.value > totalPaginas!.value}">
          <fa-icon [icon]="faChevronLeft" class="cursor-pointer"></fa-icon>
        </app-icon>

        <div class="content-input">
          <app-input d-contents>
            <input red-input redType="outline" not-label appOnlyNumbers redTextAlign="center"
              (focus)="editingPagination = paginacion.value" (blur)="changeInput(paginacion.value)"
              style="max-height: 3rem;" formControlName="PAGINA_ACTUAL" class="black2" maxlength="50" />
          </app-input>
        </div>
        <div>
          <span style="font-size: 1rem;">/{{totalPaginas!.value}}</span>
        </div>
        <app-icon [align]="'left'" (click)="next()" class="btn-next"
          [ngClass]="{'disabled': this.paginacion.value >= totalPaginas!.value}">
          <fa-icon [icon]="faAngleRight" class="cursor-pointer"></fa-icon>
        </app-icon>
      </div>
      <div class="pagination-right">
        <app-select>
          <nz-select [nzOptionHeightPx]="42" class="mb-0" appInputEffect red-select redPrimary nzShowSearch
            [ngClass]="{'fill': opcionesPaginacion!.value || opcionesPaginacion!.value == 0}" id="registro"
            formControlName="REGISTROS_POR_PAGINA" redType="outline" [nzOptionHeightPx]="42" [nzOptionOverflowSize]="10"
            name="select" (ngModelChange)="changeSelect($event)">
            @for (opcion of listadoPaginacion; track idx; let idx = $index) {
            <nz-option [nzValue]="opcion" [nzLabel]="opcion"></nz-option>
            }
          </nz-select>
          <label for="registro" red-label redBlue70>Records per page</label>
        </app-select>
      </div>
    </div>
  </section>
</main>